module.exports = __webpack_public_path__ + "img/file-checked-purple.c8322d84.svg";